module.exports = __webpack_public_path__ + "_assets/img/coin.80e9e826.svg";